//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************
import {
  Inject,
  Injectable
} from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';
import {
  Observable
} from 'rxjs';
import {
  UnitTemplateDataViewModel
} from '@generatedmodels/UnitTemplateDataViewModel';
import {
  Header
} from '@generatedmodels/Header';
import {
  SubElement
} from '@generatedmodels/SubElement';
import {
  ElementContainer
} from '@generatedmodels/ElementContainer';
import {
  SystemTypeViewModel
} from '@generatedmodels/SystemTypeViewModel';
import {
  UnitTypeViewModel
} from '@generatedmodels/UnitTypeViewModel';
import {
  DisciplineViewModel
} from '@generatedmodels/DisciplineViewModel';
import {
  SubElementTypeViewModel
} from '@generatedmodels/SubElementTypeViewModel';
import {
  UpdateTemplateHeaderModel
} from '@generatedmodels/UpdateTemplateHeaderModel';
import {
  UpdateTemplateContainerModel
} from '@generatedmodels/UpdateTemplateContainerModel';
import {
  UnitTemplateListViewModel
} from '@generatedmodels/UnitTemplateListViewModel';
import {
  UnitTemplateViewModel
} from '@generatedmodels/UnitTemplateViewModel';
import {
  ConfigureTemplateRequestModel
} from '@generatedmodels/ConfigureTemplateRequestModel';
import {
  CreateNewElementViewModel
} from '@generatedmodels/CreateNewElementViewModel';
import {
  CommissioninSheetInputPropViewModel
} from '@generatedmodels/CommissioninSheetInputPropViewModel';
import {
  TypeViewModel
} from '@generatedmodels/TypeViewModel';
import {
  TimeZoneViewModel
} from '@generatedmodels/TimeZoneViewModel';

export interface IApiCommissioningSheetService {
  getCommissioningSheetTemplate(id: number): Observable<UnitTemplateDataViewModel>;

  getCommissioningSheetTemplateByUnitTypeId(id: number): Observable<UnitTemplateDataViewModel>;

  getCommissioningSheetTemplateHeader(id: number, uniqueId: string): Observable<Header>;

  getCommissioningSheetTemplateSubElement(id: number, uniqueId: string): Observable<SubElement>;

  getCommissioningSheetTemplateContainer(id: number, uniqueId: string): Observable<ElementContainer>;

  getAllSystemTypes(): Observable<SystemTypeViewModel[]>;

  getSystemTypes(disciplineId: number): Observable<SystemTypeViewModel[]>;

  getSystemTypesByDna(disciplineId: number, dnaClientId: number): Observable<SystemTypeViewModel[]>;

  getUnitTypes(systemTypeId: number): Observable<UnitTypeViewModel[]>;

  getNotUsedUnitTypes(systemTypeId: number): Observable<UnitTypeViewModel[]>;

  getAllDisciplines(): Observable<DisciplineViewModel[]>;

  getAllUnitTypes(): Observable<UnitTypeViewModel[]>;

  getSubElementTypes(unitTypeId: number): Observable<SubElementTypeViewModel[]>;

  getAllSubElementTypes(): Observable<SubElementTypeViewModel[]>;

  createOrUpdateCommissioningSheetTemplate(commissioningSheetDataViewModel: UnitTemplateDataViewModel): Observable<void>;

  updateTemplateHeader(updateTemplateHeaderModel: UpdateTemplateHeaderModel): Observable<void>;

  updateTemplateContainer(updateTemplateContainerModel: UpdateTemplateContainerModel): Observable<void>;

  list(): Observable<UnitTemplateListViewModel[]>;

  getTemplate(id: number): Observable<UnitTemplateViewModel>;

  delete(template: UnitTemplateListViewModel): Observable<boolean>;

  copyTemplate(id: number): Observable<UnitTemplateViewModel>;

  renameTemplate(template: UnitTemplateListViewModel): Observable<boolean>;

  configureTemplate(model: ConfigureTemplateRequestModel): Observable<boolean>;

  createSystemType(systemTypeViewModel: SystemTypeViewModel): Observable<SystemTypeViewModel>;

  createUnitType(unitTypeViewModel: UnitTypeViewModel): Observable<UnitTypeViewModel>;

  createNewElement(createNewElementViewModel: CreateNewElementViewModel): Observable<CreateNewElementViewModel>;

  getAllInputProps(): Observable<CommissioninSheetInputPropViewModel[]>;

  getAllTypes(): Observable<TypeViewModel[]>;

  getTimeZones(): Observable<TimeZoneViewModel[]>;
}

@Injectable({providedIn: 'root'})
export class ApiCommissioningSheetService implements IApiCommissioningSheetService {
  private serviceName = "ApiCommissioningSheetService";

  constructor(
    @Inject(HttpClient) protected http: HttpClient) {
  }

  public get commissioningSheetServiceUrl(): string {
    return 'api/CommissioningSheetService/v2';
  }

  public getCommissioningSheetTemplate(id: number): Observable<UnitTemplateDataViewModel> {
    return this.http.get<UnitTemplateDataViewModel>(`${this.commissioningSheetServiceUrl}/GetCommissioningSheetTemplate/${id}`, {responseType: "json"});
  }

  public getCommissioningSheetTemplateByUnitTypeId(id: number): Observable<UnitTemplateDataViewModel> {
    return this.http.get<UnitTemplateDataViewModel>(`${this.commissioningSheetServiceUrl}/GetCommissioningSheetTemplateByUnitTypeId/${id}`, {responseType: "json"});
  }

  public getCommissioningSheetTemplateHeader(id: number, uniqueId: string): Observable<Header> {
    return this.http.get<Header>(`${this.commissioningSheetServiceUrl}/GetCommissioningSheetTemplateHeader/${id}/${uniqueId}`, {responseType: "json"});
  }

  public getCommissioningSheetTemplateSubElement(id: number, uniqueId: string): Observable<SubElement> {
    return this.http.get<SubElement>(`${this.commissioningSheetServiceUrl}/getCommissioningSheetTemplateSubElement/${id}/${uniqueId}`, {responseType: "json"});
  }

  public getCommissioningSheetTemplateContainer(id: number, uniqueId: string): Observable<ElementContainer> {
    return this.http.get<ElementContainer>(`${this.commissioningSheetServiceUrl}/getCommissioningSheetTemplateContainer/${id}/${uniqueId}`, {responseType: "json"});
  }

  public getAllSystemTypes(): Observable<SystemTypeViewModel[]> {
    return this.http.get<SystemTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllSystemTypes`, {responseType: "json"});
  }

  public getSystemTypes(disciplineId: number): Observable<SystemTypeViewModel[]> {
    return this.http.get<SystemTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/GetSystemTypes/${disciplineId}`, {responseType: "json"});
  }

  public getSystemTypesByDna(disciplineId: number, dnaClientId: number): Observable<SystemTypeViewModel[]> {
    return this.http.get<SystemTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/GetSystemTypesByDna/${disciplineId}/${dnaClientId}`, {responseType: "json"});
  }

  public getUnitTypes(systemTypeId: number): Observable<UnitTypeViewModel[]> {
    return this.http.get<UnitTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/GetUnitTypes/${systemTypeId}`, {responseType: "json"});
  }

  public getNotUsedUnitTypes(systemTypeId: number): Observable<UnitTypeViewModel[]> {
    return this.http.get<UnitTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/GetNotUsedUnitTypes/${systemTypeId}`, {responseType: "json"});
  }

  public getAllDisciplines(): Observable<DisciplineViewModel[]> {
    return this.http.get<DisciplineViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllDisciplines`, {responseType: "json"});
  }

  public getAllUnitTypes(): Observable<UnitTypeViewModel[]> {
    return this.http.get<UnitTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllUnitTypes`, {responseType: "json"});
  }

  public getSubElementTypes(unitTypeId: number): Observable<SubElementTypeViewModel[]> {
    return this.http.get<SubElementTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/GetSubElementTypes/${unitTypeId}`, {responseType: "json"});
  }

  public getAllSubElementTypes(): Observable<SubElementTypeViewModel[]> {
    return this.http.get<SubElementTypeViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllSubElementTypes`, {responseType: "json"});
  }

  public createOrUpdateCommissioningSheetTemplate(commissioningSheetDataViewModel: UnitTemplateDataViewModel): Observable<any> {
    return this.http.post(`${this.commissioningSheetServiceUrl}/createOrUpdateCommissioningSheetTemplate`, commissioningSheetDataViewModel, {responseType: "json"});
  }

  public updateTemplateHeader(updateTemplateHeaderModel: UpdateTemplateHeaderModel): Observable<any> {
    return this.http.post(`${this.commissioningSheetServiceUrl}/updateTemplateHeader`, updateTemplateHeaderModel, {responseType: "json"});
  }

  public updateTemplateContainer(updateTemplateContainerModel: UpdateTemplateContainerModel): Observable<any> {
    return this.http.post(`${this.commissioningSheetServiceUrl}/updateTemplateContainer`, updateTemplateContainerModel, {responseType: "json"});
  }

  public list(): Observable<UnitTemplateListViewModel[]> {
    return this.http.get<UnitTemplateListViewModel[]>(`${this.commissioningSheetServiceUrl}/list`, {responseType: "json"});
  }

  public getTemplate(id: number): Observable<UnitTemplateViewModel> {
    return this.http.get<UnitTemplateViewModel>(`${this.commissioningSheetServiceUrl}/GetTemplate/${id}`, {responseType: "json"});
  }

  public delete(template: UnitTemplateListViewModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.commissioningSheetServiceUrl}/delete`, template, {responseType: "json"});
  }

  public copyTemplate(id: number): Observable<UnitTemplateViewModel> {
    return this.http.get<UnitTemplateViewModel>(`${this.commissioningSheetServiceUrl}/CopyTemplate/${id}`, {responseType: "json"});
  }

  public renameTemplate(template: UnitTemplateListViewModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.commissioningSheetServiceUrl}/renameTemplate`, template, {responseType: "json"});
  }

  public configureTemplate(model: ConfigureTemplateRequestModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.commissioningSheetServiceUrl}/configureTemplate`, model, {responseType: "json"});
  }

  public createSystemType(systemTypeViewModel: SystemTypeViewModel): Observable<SystemTypeViewModel> {
    return this.http.post<SystemTypeViewModel>(`${this.commissioningSheetServiceUrl}/createSystemType`, systemTypeViewModel, {responseType: "json"});
  }

  public createUnitType(unitTypeViewModel: UnitTypeViewModel): Observable<UnitTypeViewModel> {
    return this.http.post<UnitTypeViewModel>(`${this.commissioningSheetServiceUrl}/createUnitType`, unitTypeViewModel, {responseType: "json"});
  }

  public createNewElement(createNewElementViewModel: CreateNewElementViewModel): Observable<CreateNewElementViewModel> {
    return this.http.post<CreateNewElementViewModel>(`${this.commissioningSheetServiceUrl}/createNewElement`, createNewElementViewModel, {responseType: "json"});
  }

  public getAllInputProps(): Observable<CommissioninSheetInputPropViewModel[]> {
    return this.http.get<CommissioninSheetInputPropViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllInputProps`, {responseType: "json"});
  }

  public getAllTypes(): Observable<TypeViewModel[]> {
    return this.http.get<TypeViewModel[]>(`${this.commissioningSheetServiceUrl}/getAllTypes`, {responseType: "json"});
  }

  public getTimeZones(): Observable<TimeZoneViewModel[]> {
    return this.http.get<TimeZoneViewModel[]>(`${this.commissioningSheetServiceUrl}/GetTimeZones`, {responseType: "json"});
  }

  public lockTemplate(id: number) {
    return this.http.put(`${this.commissioningSheetServiceUrl}/lock/${id}`, {});
  }

  public unlockTemplate(id: number) {
    return this.http.put(`${this.commissioningSheetServiceUrl}/unlock/${id}`, {});
  }
}
